export default {
  pageTitle: '广告账户授权',
  management: '授权账号管理',
  point: {
    management: '素材埋点管理',
  },
  authRange: {
    router: {
      confirm: {
        ok: '授权',
        goPl: '前往制作',
      },
      nodata: {
        title: '无可查看数据',
        noplaceDesc: '当前广告平台暂无投放可玩素材，可前往制作。',
        desc: '已授权账号的数据范围均为「不拉取」，因此无可查看数据。 可前往授权管理页修改各账号的数据范围后，查看数据。',
      },
      noadv: {
        tooltip:
          '该平台未授权广告账号。请在「常用设置」-「授权管理」授权广告账号后方可查看数据',
        title: '未授权任何平台账号',
        desc: '需先授权广告账号后，才可进入创意洞察模块查看数据。',
      },
      noReport: {
        tooltip: '该渠道暂不支持素材投放数据，仅包含交互数据',
      },
      norange: {
        title: '未设置账户素材数据范围',
        desc: '已授权账号尚未设置账户素材数据范围，设置后才可进入创意洞察。可前往授权管理页设置。',
      },
      channel: {
        nodata: {
          title: '无可查看数据',
          desc: '该平台下所有账号的数据范围均为「不拉取」，因此无可查看数据。可前往授权管理页修改数据拉取范围后，查看该平台数据。',
        },
      },
    },
    settingDialog: {
      title: '账户素材数据范围设置',
      desc: '已授权账号尚未设置素材数据范围，请选择Playturbo可拉取的第三方平台每个账号的数据范围。',
      form: {
        col: {
          trafficType: {
            title: '渠道',
          },
          accountName: {
            title: '帐号名称',
          },
          dataRange: {
            title: '数据范围',
          },
        },
      },
    },
    updateDialog: {
      title: '数据范围设置',
    },
    settting: {
      success: '修改成功',
    },
  },
  authPage: {
    description: '统一查看授权账号管理',
  },
  authLabel: '授权',
  authDialog: {
    quickAuth: {
      desc: '点击获取',
      label: '本帐号信息',
      tips: '自动填写当前账号邮箱对应的Mintegtal广告投放平台下的账号信息',
    },
    title: '账号授权',
    agreement: '《授权协议》',
    guideText: '操作指引',
    secret: '已阅读并同意',
    form: {
      dataRange: {
        label: '数据范围',
        part: 'Playturbo制作的素材',
        forbidden: '不拉取',
        all: '全部素材',
        tipsLabel:
          '时区：跟随该广告平台下主账号的时区。更新时间：对应时区 02:00 更新前一天数据',
      },
    },
  },
  table: {
    pushAccountName: '推送账号名称',
    action: {
      pushInfo: '推送素材信息',
      manage: '子账号管理',
      bind: '授权',
      unbind: '取消授权',
      delete: '删除',
      assistAccount: '协助账号管理',
    },
    column: {
      assist: '协助',
      email: '邮箱',
      account: '账号',
      status: '状态',
      action: '操作',
    },
    account: {
      sign: {
        main: '主账号',
        sub: '子账号',
      },
    },
    pushId: '推送记录ID',
    pushChannel: '推送渠道',
    search: {
      email: '邮箱',
      accountName: '账号名称',
      status: '状态',
      authTime: '授权时间',
    },
  },
  accountDialog: {
    table: {
      column: {
        accountName: '账号名称',
        traffic_type: '平台',
        authTime: '授权时间',
      },
    },
    info: {
      channel: '平台',
      email: '主账号邮箱',
      accountName: '主账号名称',
    },
    title: '子账号管理',
  },
  pushInfoDialog: {
    table: {
      column: {
        pushdownload: '下载/推送状态',
        id: '素材ID',
        name: '素材名称',
      },
    },
  },
  bindtips: {
    title: '重新授权',
    content: '确认重新授权{channel}平台的{name}吗？',
    confirm: '授权',
  },
  deletetips: {
    title: '确认删除吗？',
    desc: '确认删除 {channel} 平台的 {name} ？',
    confirm: '删除',
  },
  auth: {
    error: {
      tips: '授权状态异常，可通过新增授权再次授权该平台账号。',
    },
    success: {
      message: '授权成功',
    },
    dataRange: {
      tips: '仅拉取Playturbo产出的素材数据',
    },
    cancel: {
      title: '取消授权',
      desc: '取消授权后，将不能推送素材至该账号，也无法拉取该账号下的投放数据。确认取消授权吗？',
      confirm: '取消授权',
      cancel: '保留',
    },
  },
  delete: {
    success: {
      message: '删除成功',
    },
  },
  authStatus: {
    active: '已授权',
    unbound: '授权取消',
    disabled: '授权失败',
    pending: '授权中',
    unactive: '未授权',
  },
  assistAccountDialog: {
    title: '协助账号管理',
    addBtn: '新增协助账号',
    table: {
      name: '账号名称',
      type: '类型',
      assistantAccount: '协助账号',
      action: '操作',
    },
    closeBtn: '关闭',
  },
  addAssistAccountDialog: {
    title: '新增协助账号',
    inputName: 'Playturbo账号名称',
    successMessage: '新增协助账号成功',
  },
}
